import React from "react";
import "./contactezNous.css";
import { FaInstagram, FaFacebookF} from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import { FiPhone } from "react-icons/fi";


const ContactezNous = () => {
  return (
    <div className="main-section-contact" id="contact">
      <h1>Prenez contact avec nous</h1>
      <p>Veuillez nous contacter si vous avez des questions concernant nos services, une réservation dans l’un de nos restaurants, piscine ou spas...</p>
      <div className="contact-sections">
        
            <li>
            <div className="sm"> 
              <FaInstagram className="icon-Insta" /> 
              <a href="https:www.instagram.com/hotelsyphax?igsh=aG1maW5kcmU1a2pw" target="_blank" rel="noreferrer">Instagram</a>
              </div>
            </li>
            <li>
            <div className="sm"> 
              <FaFacebookF className="icon-Fb"  /> 
              <a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a>
              </div>
            </li>
            <li>
            <div className="sm"> 
              <BiLogoGmail  className="icon-Gmail" />
              <a href="mailto:hotelsyphax@yahoo.fr">hotelsyphax@yahoo.fr</a>
              </div>
            </li>
            <li>
              <div className="sm">           
                  <FiPhone className="icon-Phone" /> 
              <a href="tel:034816704">034816704</a>
              </div> 
            </li>
         
        </div>
      </div>
  );
};

export default ContactezNous;
